import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import saInit from '@/common/saInit'

Vue.config.productionTip = false

// 神策初始化
saInit(Vue)

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
